interface Props {
  onBack: () => void
}

export function CapabilityStatementPlaceholder({ onBack }: Props) {
  return (
    <div className="min-h-screen bg-chalk flex items-center justify-center p-6">
      <div className="max-w-xl text-center">
        <div className="font-data text-xs uppercase tracking-wide text-mint font-medium">
          Capability statement
        </div>
        <h1 className="mt-3 text-3xl sm:text-4xl font-semibold text-navy tracking-tight">
          We'll email it within one business day.
        </h1>
        <p className="mt-4 text-base text-navy/70 leading-relaxed">
          Thanks for the request — your capability statement is being assembled and a CyLogic
          team member will follow up with the PDF and any additional collateral your capture
          team needs.
        </p>
        <button
          onClick={onBack}
          className="mt-8 text-mint hover:underline font-medium"
        >
          ← Back to CyCloud
        </button>
      </div>
    </div>
  )
}
